import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "../../Assets/scss/components/payment-button.scss";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import SurveyForm from "../SurveyForm";
import { SET_MESSAGE } from "../../Actions/Types";
import { planCancelSubscriptionExtensionService } from "../../Services/SurveyDataService";

interface PropTypes {
    buttonType: number // 1 - Upgrade plan, 2 - Purchase Now or Renew Plan, 3 - cancel plan, 4 - Reactivate plan
    buttonVariant?: string
    buttonBigSize?: boolean
    buttonLabel?: string
    isIconBtn?: boolean,
    upgradePopup?: boolean;
    forNewPurchase?: boolean;
}
const ExtensionUserCancelButtonBlock = (props: PropTypes) => {

    // Props
    const { buttonType, buttonVariant, buttonBigSize, buttonLabel, isIconBtn, upgradePopup, forNewPurchase } = props;

    // Redux Data
    const user = useSelector((store: StoreProptypes) => store.user);
    const accessToken = useSelector((store: StoreProptypes) => store.accessToken);

const { websites,  currentWebsite } = useSelector((store: StoreProptypes) => store);
    // Functions
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // States
    const [disabledButton, setDisabledButton] = useState<boolean>(false);

    // Survey Form State
    const [showSurveyFormModal, setShowSurveyFormModal] = useState(false);
    const [surveyFormReason, setSurveyFormReason] = useState<number>(0);
    const [surveyFormReasonText, setSurveyFormReasonText] = useState<string>('');

    const dataPermission = websites?.filter((i: any) => i?.website_domain === currentWebsite?.domain)
    const paymentSettings = dataPermission && dataPermission[0]?.permissions?.find((i: any) => i?.name === "payment_allowed");

    // Disabled Button Functions
    useEffect(() => {
        if ((user && user.department === 1) || ((user?.parent_id !== 0 &&  user?.parent_id !== 1) && paymentSettings?.name !== "payment_allowed")) {
            setDisabledButton(true);
        } else {
            setDisabledButton(false);
        }
    }, [user, paymentSettings])

    const handleCloseSurveyFormModal = () => {
        setShowSurveyFormModal(false);
    }

    const handleShowSurveyFormModal = () => {
        setShowSurveyFormModal(true);
    }

    const handleCancelPlan = () => {
        if (surveyFormReason === 0) {
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    "toast_message": t('Please select cancel reason.'),
                    "toast_type": 'danger'
                }
            })
        } else {
            if (accessToken && user && user.current_active_package.length > 0) {
                planCancelSubscriptionExtensionService(accessToken, user.current_active_package[0].package_id, dispatch, t, navigate,surveyFormReason, surveyFormReasonText, user.current_active_package[0].user_package_id);
                handleCloseSurveyFormModal();
            }
        }
    }

    return (
        <>
           <Button
                variant={`${buttonVariant ? buttonVariant : `primary`}`}
                className={`${buttonBigSize ? `btn-lg` : ``} w-100`}
                disabled={disabledButton}
                onClick={() => handleShowSurveyFormModal()}
            >
                {t(`${buttonLabel && buttonLabel !== "" ? buttonLabel : `Cancel Plan`}`)}
            </Button>

            <Modal show={showSurveyFormModal} onHide={handleCloseSurveyFormModal} size="xl" backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>                        
                            <>
                                {t(`reject special offer model title`)}
                            </>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <SurveyForm
                            surveyFormReason={surveyFormReason}
                            setSurveyFormReason={setSurveyFormReason}
                            surveyFormReasonText={surveyFormReasonText}
                            setSurveyFormReasonText={setSurveyFormReasonText}
                        />
                    </>
                </Modal.Body>
                    <>
                        <Modal.Footer>
                            <div className="cancle-popup-btn">
                                <Button size="lg" variant="primary" onClick={() => handleCancelPlan()}>{t('Cancel Plan')}</Button>
                                <Button size="lg" variant="danger" onClick={handleCloseSurveyFormModal}>{t('Close')}</Button>
                            </div>
                        </Modal.Footer>
                    </>
            </Modal>
        </>
    )
}

export default ExtensionUserCancelButtonBlock;
